/** Situações dos pacotes de campanhas */
export interface PacoteCampanhaSituacao {
    id: number;
    nome: string;
}

export const pacoteCampanhaSituacaoAtivo: PacoteCampanhaSituacao = {id: 1, nome: 'Ativo'};
export const pacoteCampanhaSituacaoInativo: PacoteCampanhaSituacao = {id: 2, nome: 'Inativo'};

export const pacoteCampanhaSituacoes: PacoteCampanhaSituacao[] = [
    pacoteCampanhaSituacaoAtivo,
    pacoteCampanhaSituacaoInativo
];

/** Verifica se a situação informada é igual a Ativo */
export function isSituacaoAtivo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === pacoteCampanhaSituacaoAtivo.id;
}

/** Verifica se a situação informada é igual a Inativo */
export function isSituacaoInativo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === pacoteCampanhaSituacaoInativo.id;
}
